var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Student } from '@/models/Student';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { avatarHtml } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import { Guardian } from '@/models/Guardian';
import ErrorHandler from '@/support/ErrorHandler';
let AddGuardianDialog = class AddGuardianDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedUsers = [];
        this.users = [];
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('group.guardian', 1),
                plural: this.$tc('group.guardian', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                { text: this.$t('name.title'), value: 'name' },
            ],
            actions: [],
            filters: [],
            model: new Guardian(),
        };
    }
    close() {
        this.$emit('input', false);
    }
    createRelationships() {
        const relations = [];
        this.selectedUsers.forEach((user) => {
            const item = {
                type: 'guardian',
                user: user.id,
            };
            relations.push(item);
        });
        return relations;
    }
    update() {
        // (this.student as any).relationships = this.createRelationships();
        this.student
            .include('relationships')
            .update({ relationships: this.createRelationships() })
            .then((student) => {
            this.$emit('guardians-added');
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    mounted() {
        //
    }
};
__decorate([
    Prop({ default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], AddGuardianDialog.prototype, "student", void 0);
AddGuardianDialog = __decorate([
    Component({
        components: {
            DataTable,
        },
    })
], AddGuardianDialog);
export default AddGuardianDialog;
